<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="prol"> </p>
<p class="CT">Prologue: Barsoom</p>
<p class="sp"> </p>
<p class="CO"><span class="SC-B">TWO BRIGHT MOONS CHASED</span> each other across a butterscotch sky. Down on the plain, something big was galloping, its feet touching down only once a second. It was too far away to make out what it was, but the broad-shouldered man on the balcony could see each puff of dust it left and the long line of them leading away.</p>
<p class="TX">Whatever it was, it was drawing that line at an angle to a much bigger mark—an ancient canal, dry now for thousands of years, that swept in from one horizon, passed this lonely peak with its crumbled towers and collapsed stairs, and exited the scene over the opposite horizon. Dunes were trying to erase the canal, but they’d never succeed.</p>
<p class="TX">The gray-haired man smoothed his hand along the stone banister. It had amused him to leave its ancient worn stone intact when he renovated this palace. He’d done the same with the rest of the mountain peak—balcony, tower, and dome had all been preserved where they could be. The result was a jarring mix of sharp new edges and worn, almost natural curves, but he liked that.</p>
<p class="TX">His moment of contentment was interrupted by approaching footsteps. It was easy to tell by their nervous, clipped gait that it was his most trusted adviser, Memorum. Normally Memorum simply said what was on his mind, but this time he stopped and didn’t even clear his throat.</p>
<p class="TX">“What?” He turned to shoot a bemused look at the man. “Did somebody die?”</p>
<p class="TX">Memorum didn’t answer, and for a moment the gray-haired man wondered if somebody had. He stepped away from the rail. “Is she—”</p>
<p class="TX">“<span class="ePub-I">They found him.</span>”</p>
<p class="TX">“Ah.” He turned back to the view, reaching deliberately for the stone to steady himself. “Ah. Really.” It took him awhile to work up the courage for the next question.</p>
<p class="TX">“Alive?”</p>
<p class="TX">“Yes, sir, as best we can tell.”</p>
<p class="TX">He shook his head in wonder. “We built ’em good in the old days.”</p>
<p class="TX">“It’s been forty years.”</p>
<p class="TX">“I think we can agree it’s been longer than that.” He ran his hands along the balustrade again.</p>
<p class="TX">There was a long silence, then Memorum said, “What do we do now?”</p>
<p class="TX">“What do we <span class="ePub-I">do</span>? You know what to do, Memorum. He can’t be allowed back.”</p>
<p class="TX">“But—sir!”</p>
<p class="TX">“You heard me. Send him on if he’s still wintering over, or kill him if he’s not. Either way … he can’t be allowed back.”</p>
<p class="TX">“Sir, it’s not my place, but he’s still—”</p>
<p class="TX">“It’s been forty years, Memorum. He’s nothing to me.”</p>
<p class="TX">“And what is he to <span class="ePub-I">her</span>?”</p>
<p class="TX">He glared at his servant. “That’s none of your business!”</p>
<p class="TX">“But she’s waited so long—”</p>
<p class="TX">“She can continue to wait.”</p>
<p class="TX">He walked away, across flagstones so old they were worn from the generations of feet that had crisscrossed them.</p>
<p class="TX">“She made her choice to wait for him rather than stay with us. Let her wait till the end of time, for all I care.”</p>
<p class="TX">Memorum left, and after the servant’s footsteps had faded, the gray-haired man staggered to sit on an ancient stone seat that looked out over the plain. With no one to see him do it, he hugged himself and bent forward, gasping.</p>
<p class="TX">He knew he would always remember this: the quality of the brass-lit sky, the puffs of dust from that running beast on the plain, how the red stone of the balcony rail had felt under his fingers just before he heard the news.</p>
<p class="TX">And he knew he would always remember, and always wish he could forget, how he felt about himself right now.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?46d34c0b